import CustomText from "@components/CustomText";
import { meta } from "@constants/cplp";
import React from "react";
import { StyleSheet, TouchableNativeFeedback, View } from "react-native";

const AddToBagBtn = ({ handleAddToBag, isAllDefective }) => {
  return (
    <TouchableNativeFeedback testID="add_to_bag_btn" onPress={handleAddToBag}>
      <View style={styles.container}>
        <CustomText variant="title_18" style={{ color: "white" }}>
          {isAllDefective ? meta.submit : meta.add_to_bag_cta}
        </CustomText>
      </View>
    </TouchableNativeFeedback>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: "rgba(0, 171, 89, 1)",
    paddingVertical: 10,
    alignItems: "center",
    borderRadius: 8,
  },
});

export default AddToBagBtn;
